import { action, atom } from '@reatom/framework'

import { localStorage } from '@blade/std-lib'
import { STORAGE_PREFIX } from '@root/shared'

import {
  DEFAULT_DISPLAY,
  parseDisplay,
  serialiseDisplay,
  setDensity,
  toggleColumn,
  toggleField,
} from './board-display'

import type {
  BoardDisplay,
  ColumnKey,
  Density,
  FieldKey,
} from './board-display'

const STORAGE_KEY = `${STORAGE_PREFIX}/v1/pulse-v2/display`

/** What this reader has chosen to see, restored from their last visit. */
export const boardDisplayAtom = atom(
  parseDisplay(localStorage.get(STORAGE_KEY)),
  'boardDisplayAtom',
)

const keep = (display: BoardDisplay) => {
  localStorage.set(STORAGE_KEY, serialiseDisplay(display))
  return display
}

export const setBoardDensityAction = action((ctx, density: Density) => {
  boardDisplayAtom(ctx, keep(setDensity(ctx.get(boardDisplayAtom), density)))
}, 'setBoardDensityAction')

export const toggleBoardColumnAction = action((ctx, key: ColumnKey) => {
  boardDisplayAtom(ctx, keep(toggleColumn(ctx.get(boardDisplayAtom), key)))
}, 'toggleBoardColumnAction')

export const toggleBoardFieldAction = action((ctx, key: FieldKey) => {
  boardDisplayAtom(ctx, keep(toggleField(ctx.get(boardDisplayAtom), key)))
}, 'toggleBoardFieldAction')

export const resetBoardDisplayAction = action((ctx) => {
  localStorage.delete(STORAGE_KEY)
  boardDisplayAtom(ctx, DEFAULT_DISPLAY)
}, 'resetBoardDisplayAction')
